import { defineComponent } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import OrganisationLinkingSearchInput from '@/presentation/components/organisation-linking/organisation-linking-search/search-input.vue';
import LinkedOrganisationsOverview
	from '@/presentation/components/organisation-linking/linked-organisations-overview/linked-organisations-overview.vue';
import UnlinkOrganisationWarningModal
	from '@/presentation/components/organisation-linking/unlink-organisation-warning-modal/unlink-organisation-warning-modal.vue';
import OrganisationLinkingCode from '@/presentation/components/organisation-linking/organisation-linking.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		OrganisationLinkingSearchInput,
		LinkedOrganisationsOverview,
		UnlinkOrganisationWarningModal
	},
	setup: () => {
		const code = new OrganisationLinkingCode();

		return {
			isLoading: code.isLoading,
			isUnlinkOrganisationWarningActive: code.isUnlinkOrganisationWarningActive
		};
	}
});
